var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "stacked-moments-modal",
        visible: true,
        size: "lg",
        "hide-footer": "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("close")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.modalTitle) } }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-list-group",
        _vm._l(_vm.items, function (item) {
          return _c(
            "b-list-group-item",
            {
              key: item.id,
              staticClass: "d-flex justify-content-between align-items-center",
              class: { "ending-soon": item.ending },
              attrs: { button: !item.ending && _vm.getMomentStatus(item) },
              on: {
                click: function ($event) {
                  return _vm.openReservationModal(item)
                },
              },
            },
            [
              _c("div", [
                _c("div", [
                  _c("strong", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.format(new Date(item.start), "HH:mm")) +
                        " - " +
                        _vm._s(
                          _vm.format(
                            new Date(item.originalEnd || item.end),
                            "HH:mm"
                          )
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                item.extendedProps["Location.Name"]
                  ? _c("div", { staticClass: "small" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.extendedProps["Location.Name"]) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.getMomentStatus(item)?.date
                  ? _c("div", [
                      _vm.getMomentStatus(item)?.identification ===
                        "reservations_open_at" ||
                      _vm.getMomentStatus(item)?.identification ===
                        "reservations_closed_at"
                        ? _c(
                            "span",
                            { staticClass: "text-info" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: _vm.icons.faInfoCircle },
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "timetable." +
                                        _vm.getMomentStatus(item)
                                          .identification,
                                      {
                                        date: _vm.format(
                                          _vm.getMomentStatus(item).date,
                                          new Date(
                                            _vm.getMomentStatus(item).date
                                          ).toDateString() ===
                                            new Date().toDateString()
                                            ? `HH:mm`
                                            : `dd-MM-yyyy '${_vm.$t(
                                                "common.at"
                                              )}' HH:mm`
                                        ),
                                      }
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.getMomentStatus(item)
                ? [
                    _c(
                      "div",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              size: "sm",
                              variant: _vm.getMomentStatus(item).variant,
                              disabled: !_vm.getMomentStatus(item).canReserve,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openReservationModal(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.getMomentStatus(item).text) +
                                "\n                        "
                            ),
                            _vm.getMomentStatus(item).showQueueCount &&
                            item.extendedProps.QueueQuantity > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "badge badge-pill badge-light",
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          item.extendedProps.QueueQuantity
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }